module.exports = __webpack_public_path__ + "img/italy.27f644c0.svg";